import { Injectable } from "@angular/core";
import { RestService } from "../../../core/core/rest.service";
import { StructureUserRole } from "../../structure/structure-users.model";
import { User, UserPositionRow } from "../users.model";
import { ObjectToSelect } from "../../../core/shared/objectToSelect.model";
import { Employee } from "../../employees/employee.model";

@Injectable()
export class UserDetailsRest {
    constructor(private http: RestService) { }
    
    public getUserDetails(userName) {
        return this.http.get<User>(`api/users/${userName}`);
    } 

    public deleteUser(userName: string){
            return this.http.post('api/user/deactivate', userName);
    }

    public activateUser(id: string){
        return this.http.post('api/user/activate', id);
    }

    public markPasswordChange(id: string){
        return this.http.post('api/markPasswordChange', id);
    }

    public getUserRoles() {
        return this.http.get<StructureUserRole[]>('api/user/roles/all');
    }

    public addUserPosition(userPosition:UserPositionRow)
    {
        return this.http.post('api/user/positions/add', userPosition)
    }

    public editUserPosition(userPosition:UserPositionRow)
    {
        return this.http.post('api/user/positions/edit', userPosition)
    }

    public deleteUserPosition(userPositionId:Int32Array)
    {
        return this.http.post('api/user/positions/delete', userPositionId)
    }

    public addUser(user: User){
        return this.http.post('api/user/add', user);
    }

    public editUser(user: User){
        return this.http.post('api/user/edit', user);
    }

    public getAllUsers() {
        return this.http.get<User[]>('api/users/all');
    }

    public getUserRoleName(userId: string) {
        return this.http.get<string>(`api/user/role/${userId}`);
    }

    public editUserPicture(userPictureData: any)
    {
        return this.http.post('api/user/picture/edit', userPictureData);
    }

    public getEmployeesRows() {
        return this.http.get<ObjectToSelect[]>('api/user/employees');
    }

    public getEmployee(employeeID: number) {
        return this.http.get<Employee>(`api/employees/get/${employeeID}`);
    }

    public getSelectRoles() {
        return this.http.get<ObjectToSelect[]>('api/user/select/roles');        
    }
}
